export default __webpack_public_path__ + "static/media/dull-hammer.e4b7b24e.svg";